import { http, HttpResponse } from 'msw';

import { MockServiceWorker } from '../mockServiceWorker';
import { getNextState } from './patchApplicationHandlers';

export const complementaryConsolidationHandler = [
    http.patch('*/api/cl_loanapp_proxy_service/v1/:countryCode/consolidation/:arn', async () => {
        // Simulate the next step in the flow
        const session = MockServiceWorker.getMockedSession();
        session.state = getNextState('COMPLEMENT_INFORMATION_CONSOLIDATIONS');
        MockServiceWorker.setMockedSession(session);

        return HttpResponse.json([]);
    }),
];
